import { render, staticRenderFns } from "./DetailLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=template&id=bfc6ae76&scoped=true"
import script from "./DetailLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
export * from "./DetailLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
import style0 from "./DetailLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=style&index=0&id=bfc6ae76&prod&lang=scss&scoped=true"
import style1 from "./DetailLayoutTwoColumnsNoFixedCollapsible.vue?vue&type=style&index=1&id=bfc6ae76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc6ae76",
  null
  
)

export default component.exports